import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TranslateService } from '@ngx-translate/core';

import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translateService = inject(TranslateService);

  readonly langSignal = toSignal(
    this.translateService.onLangChange.pipe(map(event => event.lang)),
    {
      initialValue: this.translateService.getCurrentLang(),
    }
  );
}
